import { Optional } from 'types/util/Optional';
import { highlight } from 'utils/stringUtils';

export interface ISearchTextProps {
  text: string;
  search: Optional<string>;
  wrap: boolean;
}

function SearchText({ text, search, wrap }: ISearchTextProps) {
  if (search) {
    return <>{highlight(text, search, wrap)}</>;
  }
  return <>{text}</>;
}

export default SearchText;
